/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { Helmet } from "react-helmet";
import YoutubeEmbedVideo1 from "../components/youtubeEmbedVideo1";
import YoutubeEmbedVideo2 from "../components/youtubeEmbedVideo2";

export const GriefSupport: React.FC = () => {
    return(
        <>
            <Helmet>
                <title>Grief Support - Jewish Cemetery</title>
                <meta name="description" content="This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us." />
            </Helmet>

            <div className="jc-grid mx-auto" style={{maxWidth: "1028px"}}>
                <p className="d-flex flex-column jc-txt-body jc-txt-dark fs-6">
                    <span className="jc-txt-heading fs-3 mb-4">Grief Support</span>

                    <iframe style={{borderRadius: "24px", marginBottom: "24px"}} src="https://open.spotify.com/embed/show/0JAu9U0t4YT5D6n9y0Dtlp?utm_source=generator" width="100%" height="352" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                    <div className="link-grief-support d-flex flex-column gap-3">
                        <YoutubeEmbedVideo1 />
                        <YoutubeEmbedVideo2 />
                    </div>
                </p>
            </div>
        </>
    );
}